import React from 'react'
import { Table, Typography } from 'antd'

import summaryReportData, { ReportColumnSummaryInfo } from './utils/summaryReportData'

const { Text } = Typography

export interface EAReportTableSummaryProps {
  columns?: ReportColumnSummaryInfo[]
  dataSource?: Record<string, unknown>[]
}

const EAReportTableSummary: React.FC<EAReportTableSummaryProps> = ({ columns = [], dataSource = [] }) => {
  const hasSummary = columns.some((column) => column.summary === true)

  if (!hasSummary || dataSource.length === 0) return null

  const summaryData = summaryReportData(columns, dataSource)

  return (
    <Table.Summary>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={columns.length}>
          <Text strong>Total</Text>
        </Table.Summary.Cell>
      </Table.Summary.Row>

      <Table.Summary.Row>
        {summaryData.map((summary, idx) => (
          <Table.Summary.Cell align={summary.align} index={idx} key={summary.dataIndex}>
            {summary.total_str}
          </Table.Summary.Cell>
        ))}
      </Table.Summary.Row>
    </Table.Summary>
  )
}

export default EAReportTableSummary
